import { RANK, createTopPostsControls } from '../topPostsControls';
import { INSTAGRAM_METADATA_BY_KEY } from 'utils/metrics';

/** Instagram's Top Posts controls. See ../topPostsControls.jsx. */
export const RANK_TYPES = {
    LAST_WEEK_LIKES: RANK.LAST_WEEK,
    AVG_WEEKLY_LIKES: RANK.AVG_WEEKLY,
    TOTAL_POST_LIKES: RANK.TOTAL_POST,
};

export const useTopPostsControls = createTopPostsControls({
    metadata: INSTAGRAM_METADATA_BY_KEY,
    // These reach the API as `rank_type` and enter queryKey[1]; byte-identical.
    metricKeys: {
        [RANK.LAST_WEEK]: 'last_week_likes',
        [RANK.AVG_WEEKLY]: 'avg_weekly_likes',
        [RANK.TOTAL_POST]: 'total_post_likes',
    },
    wowKey: 'wow',
    menuAlign: 'left',
    // Mixpanel `Change` property values. External reports segment on these.
    eventRankTypes: {
        [RANK.LAST_WEEK]: 'LAST_WEEK_LIKES',
        [RANK.AVG_WEEKLY]: 'AVG_WEEKLY_LIKES',
        [RANK.TOTAL_POST]: 'TOTAL_POST_LIKES',
    },
});

export default useTopPostsControls;
